import { NUMBER } from "../../constants/app-constants";

const CALL_SUPPORT_START_TIME = NUMBER.EIGHT;
const CALL_SUPPORT_END_TIME = NUMBER.TWENTY;

const SELL_SUPPORT_START_TIME = NUMBER.EIGHT;
const SELL_SUPPORT_END_TIME = NUMBER.TWENTY;

const WHATSAPP_SUPPORT_START_TIME = NUMBER.NINE;
const WHATSAPP_SUPPORT_END_TIME = NUMBER.SEVENTEEN;

export const currentHour = +(new Date().getHours().toLocaleString());
export const isCallSupportAvailable = currentHour >= CALL_SUPPORT_START_TIME && currentHour < CALL_SUPPORT_END_TIME;
export const isWhatsappSupportAvailable = currentHour >= WHATSAPP_SUPPORT_START_TIME && currentHour < WHATSAPP_SUPPORT_END_TIME;
export const isSellSupportAvailable = currentHour >= SELL_SUPPORT_START_TIME && currentHour < SELL_SUPPORT_END_TIME;
